<template>
    <div class="modal" :id="'external_link_modal_' + eventSchedule.id">
        <div class="m-auto w-full p-0 my-10 max-w-7xl">
            <div class="bg__container">
                <div class="modal__content p-3 md:p-32 lg:py-32 lg:mx-16">
                    <div class="top relative">
                        <button class="btn--secondary-modal absolute" style="top: 0; right: 0;" @click.prevent="close">
                            <img style="width: 35px;" src="/assets/img/soundrink_modal_close.png" />
                        </button>
                        <div class="flex flex-col md:flex-row gap-4 pt-12 md:pt-0" style="min-height: 225px;">
                            <div
                                class="image flex-1"
                                :style="{
                                    backgroundImage:
                                        'linear-gradient(360deg, #000000 0%, rgba(0,0,0, 0) 97.9%), url(' +
                                        eventSchedule.external_ticket_modal_image +
                                        ')'
                                }"
                            ></div>
                            <div class="flex-1" style="vertical-align: top;">
                                <table>
                                    <tr>
                                        <td style="color: #9B9B9B; font-size: 14px;">
                                            {{ formatDate(this.eventSchedule.date) }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="color: #fff; font-size: 20px; font-weight: bold;">
                                            {{ this.eventSchedule.event.title }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="color: #80BE27; font-size: 16px;">
                                            {{ this.eventSchedule.standing_title }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="color: #fff; font-size: 14px;">{{ this.eventSchedule.location }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="middle mt-8 md:mt-0"></div>
                    <div class="bottom  pb-8 md:pb-0">
                        <div class="flex justify-center flex-col md:flex-row gap-4 p-2 my-4">
                            <div class="form__label">Password:</div>
                            <div
                                id="form__password"
                                class="cursor-pointer flex justify-center align-items-center rounded-full px-3"
                                @click="copyUrlToClipboard(eventSchedule.external_ticket_modal_discount_code)"
                            >
                                <span
                                    :id="'password-element-holder-' + eventSchedule.id"
                                    style="font-size: 20px; font-weight: bold; margin-top: 10px; padding-left: 15px; padding-right: 15px;"
                                    >{{ eventSchedule.external_ticket_modal_discount_code }}</span
                                >
                                <span style="display: inline; float: right; margin-top: 4px;">
                                    <img style="width: 35px;" src="/assets/img/copy-stars.png" />
                                </span>
                            </div>
                        </div>

                        <div class="content">
                            <p>{{ this.eventSchedule.external_ticket_modal_text }}</p>
                        </div>

                        <a
                            class="w-full px-8 py-4 rounded-full text-white get-tickets-btn text-lg font-bold tracking-wide"
                            target="_blank"
                            :href="eventSchedule.external_ticket_modal_url"
                        >
                            <span>{{ __("Get Tickets") }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment-timezone";
export default {
    name: "sound-rink-external-link-modal",

    props: {
        eventSchedule: {
            type: Object,
            required: true
        }
    },

    data: () => ({
        showExternalLinkModal: false
    }),
    methods: {
        close() {
            this.$emit("close", true);
        },
        formatDate(value) {
            if (value) {
                return moment(String(value)).format("MMM Do Y");
            }
        },
        copyUrlToClipboard(text) {
            const clipboardData =
                event.clipboardData ||
                window.clipboardData ||
                event.originalEvent?.clipboardData ||
                navigator.clipboard;

            clipboardData.writeText(text);
            const element = document.getElementById("password-element-holder-" + this.eventSchedule.id);
            element.innerText = "Copied!";
        }
    }
};
</script>
<style lang="scss" scoped>
.modal {
    height: 100%;
}
#external_link_modal {
    display: none;
    text-align: center;
}
.mb-5 {
    margin-bottom: 1.25rem;
}
.mt-7 {
    margin-bottom: 1.75rem;
}
.mr-3 {
    margin-right: 0.75rem;
}
.mr-2 {
    margin-right: 0.5rem;
}
.bottom {
    text-align: center;
    margin: auto;
}
.top {
    color: #fff;
    margin: auto;
    text-align: center;
    padding: 3%;
    padding-bottom: 0px;
    margin-bottom: 0px;
}
.middle {
    text-align: center;
    width: 99%;
    border-bottom: 3px dashed #fff;
}
.top table {
    padding: 5%;
    margin-top: 10px;
    text-align: left;
    margin-left: 10%;
    padding-bottom: 0px;
    margin-bottom: 0px;
}
.form__label {
    font-weight: bold;
    font-size: 22px;
    padding-top: 15px;
}
#form__password {
    background-color: #2e2e2e;
    border: 1px solid #80be27;
    color: #fff;
    height: 50px;
}
.get-tickets-btn {
    background-color: #80be27;
    text-decoration: none;
}
.get-tickets-btn:hover {
    background-color: #80be27;
    text-decoration: underline;
    color: #ffffff;
}
.btn--secondary-modal {
    // margin: 0px;
    // padding: 0px;
}
.btn--secondary-modal:hover {
    background-color: #404241;
}
.bg__container {
    background-position: center center;
    background-image: url("/assets/img/soundrink_modal_bg.png");
    // height: 80%; /* You must set a specified height */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover; /* Resize the background image to cover the entire container */
    border-radius: 25px;
}
.modal__container {
    margin-left: auto;
    margin-right: auto;
    padding: 0px;
}
.modal__content {
    text-align: center;
    color: #fff;
    max-height: 90vh;
    overflow-y: auto;

    background-color: #2e2e2e;

    @media (min-width: 768px) {
        background-color: unset;
    }

    .content {
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        max-width: 350px;
        color: #fff;
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 5%;
    }
}
.modal__close {
    margin-top: 10px;
}
.image {
    min-height: 225px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top center;
    border-radius: 20px;

    @media (min-width: 768px) {
        border-radius: 20px 20px 0 0;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/SoundRinkExternalLinkModal.vue